import React from 'react'

import { withRouter } from 'react-router-dom'

const Event = ({ history }) => {
  return (
    <nav
      className="navbar d-flex align-items-center justify-content-start "
      style={{
        position: 'fixed',
        top: '0',
        width: '100%',
        height: '59px',
        zIndex: 1
      }}
    >
      <div onClick={() => history.goBack()}>
        <i
          className="fas fa-arrow-left"
          style={{ color: '#fff', fontSize: '1.2rem' }}
        />
      </div>
    </nav>
  )
}

export default withRouter(Event)
